// extracted by mini-css-extract-plugin
export var cellDetails = "cell-module--cellDetails--9db51";
export var cellHeader = "cell-module--cellHeader--b94ed";
export var cellHeaderWrapper = "cell-module--cellHeaderWrapper--c287e";